export const PAGINATION_COUNT_ITEMS_PER_PAGE = 10;

export const FallbackArticle = {
	content: ['null'],
	slug_path: '',
	file: '',
	download_count: 0,
	view_count: 0,
	dictionary_name: '',
};
